import { render, staticRenderFns } from "./ListarYSubirArchivos.vue?vue&type=template&id=5c10a00c&scoped=true"
import script from "./ListarYSubirArchivos.vue?vue&type=script&lang=js"
export * from "./ListarYSubirArchivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c10a00c",
  null
  
)

export default component.exports